import * as React from 'react';
import { useEffect, useState } from 'react';
import { useProductStore } from 'src/hooks/product';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/support/Helper';
import FadeInOut from "../../../../component/FadeInOut";

const ProductDetailDocumentTab = (props) => {
    const [product_document_API_call] = useReduxState(false, 'product_document_API_call');
    const [{ product_document_data, productDetail, product_document_count }, { fetch_product_document_list }, { }] = useProductStore();
    const [productDocumentList, setProductDocumentList] = useState([])
    const [orderby, setOrderby] = useState('');
    const [orderbyDirection, setOrderbyDirection] = useState('asc');

    useEffect(() => {
        async function fetchHere() {
            await getProductDocument()
        }

        if (product_document_API_call !== false) {
            fetchHere()
        }
    }, [product_document_API_call]);

    useEffect(() => {
        async function fetchHere() {
            await fetchFromServer()
        }

        if (product_document_API_call !== false) {
            fetchHere()
        }
    }, [product_document_data]);

    useEffect(() => {
        async function fetchHere() {
            await getProductDocument();
        }

        if (product_document_API_call !== false) {
            fetchHere()
        }
    }, [orderby, orderbyDirection])

    const getProductDocument = async () => {
        if (productDetail !== undefined && productDetail.value !== undefined) {
            let ItemNumber = productDetail.value.ItemNumber

            let params = {}
            params.filter = "ItemNum  eq " + "'" + ItemNumber + "'";
            params.top = product_document_count
            params.orderby = ((orderby !== '' ? orderby : 'Title') + ' ' + orderbyDirection),
                await fetch_product_document_list(params)
        }
    }

    const fetchFromServer = async () => {
        await setProductDocumentList(product_document_data);
    }

    const getOrderByClass = (columnName) => {
        if (columnName === orderby) {
            return 'sorting sorting_' + orderbyDirection
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        let d = orderbyDirection;
        if (d === 'desc') {
            d = 'asc';
        } else if (d === 'asc') {
            d = 'desc';
        }
        setOrderbyDirection(d);
        setOrderby(columnName);
    };

    return (
        <>
            <div className="tab-pane fade" id="tab3">
                {
                    productDocumentList !== undefined && productDocumentList.length > 0 &&
                    <FadeInOut show={true} duration={500}>
                        <table className="bs5 table table-bordered">
                            <thead>
                                <tr>
                                    <th className={'font-14 text-none ' +
                                        getOrderByClass('Title')
                                    }
                                        onClick={async () => {
                                            await toggleOrderBy('Title')
                                        }}>TITLE</th>
                                    <th className={'font-14 text-none ' +
                                        getOrderByClass('DocumentType')
                                    }
                                        onClick={async () => {
                                            await toggleOrderBy('DocumentType')
                                        }}>TYPE</th>
                                    <th className={'font-14 text-none ' +
                                        getOrderByClass('DatePublished')
                                    }
                                        onClick={async () => {
                                            await toggleOrderBy('DatePublished')
                                        }}>DATE PUBLISHED</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    productDocumentList.map((v, i) => (
                                        <tr>
                                            <td>
                                                <a href={v.AssetUrl} target="_blank" className="text-bold">
                                                    {v.Title || v.LongDescription }
                                                </a>
                                            </td>
                                            <td>
                                                {v.DocumentType}
                                            </td>
                                            <td>
                                                {Helper.dateFormatFromString(v.DatePublished,true)}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </FadeInOut>
                }
            </div>
        </>
    );
}

export default ProductDetailDocumentTab;